import { adminSearchShardCatalogDetailsGetSlice } from './post';

export const {
	requestPostAdminSearchShardCatalogReindexCustomer,
	resetPostAdminSearchShardCatalogReindexCustomer
} = adminSearchShardCatalogDetailsGetSlice.asyncActionCreators;
